import Cookies from "js-cookie";
import { LogoutHandler } from "../Redux/userSlice";
import { resetPnlFilters } from "../Redux/pnlFilterSlice";
import { resetCashflowFilters } from "../Redux/cashflowFilterSlice";

// This function handles the logout process without using hooks.
export function performLogout(dispatch) {
  ////console.log('Logging out user');
  // Clear tokens
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");

  // Reset accounting filters
  dispatch(resetPnlFilters());
  dispatch(resetCashflowFilters());

  // Dispatch logout action
  dispatch(LogoutHandler());
  // toast.info('Session Ended !');
}
